// components/filter/index

function Filter() {
    this.filter = document.querySelector(".filter");
    if (this.filter) {
        this.label = this.filter.querySelector(".filter__label");
    } else {
        return false;
    }

    if (this.filter.nodeType !== 1) {
        return false;
    }

    this.eventListeners();
}

Filter.prototype.eventListeners = function() {
    this.events = {
        body: this.bodyClick.bind(this)
    };

    this.label.addEventListener("click", this.onClick.bind(this), false);



    this.filter.addEventListener("click", function (e) {
        e.stopPropagation();
    });
};

Filter.prototype.bodyClick = function () {
    this.filter.classList.remove("is-open");
};

Filter.prototype.onClick = function () {
    this.filter.classList.toggle("is-open");
    document.addEventListener("click", this.events.body);

};

export default Filter;



// WEBPACK FOOTER //
// ./js/components/filter/index.js